import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ObjectViewLayout from '@/components/layouts/ObjectViewLayout';
import { EditPolicyTransactionDialog } from '@/components/dialogs/EditLinkedPolicyTransactionDialog';
import { PoliciesSelectProvider } from '@/context/policiesContext';
import { CompleteDealDialog } from '@/components/dialogs/CompleteDealDialog';
import { FolioErrorBoundary } from '@/components/layouts/FolioErrorBoundary';
import { DebtorTabView } from './DebtorTabView';
import { DebtorsAboutCard } from './DebtorsAboutCard';

const DebtorViewWrapper = () => {
	const { dealId } = useParams();
	const completeDealOpen = useSelector((state) => state.dialog.open?.completeDeal);

	return (
		<ObjectViewLayout
			tabView={<DebtorTabView />}
			aboutCard={
				<FolioErrorBoundary
					dealId={dealId}
					key={`${dealId}-debtors`}
					message='Error loading content'
					context='DebtorViewWrapper'
				>
					<DebtorsAboutCard />
				</FolioErrorBoundary>
			}
		>
			<PoliciesSelectProvider>
				<EditPolicyTransactionDialog />
			</PoliciesSelectProvider>
			{completeDealOpen && (
				<PoliciesSelectProvider>
					<CompleteDealDialog />
				</PoliciesSelectProvider>
			)}
		</ObjectViewLayout>
	);
};

DebtorViewWrapper.displayName = 'DebtorViewWrapper';

export default DebtorViewWrapper;
